<template>
  <section class="signup">
    <div class="container-fluid">
      <h2 class>修改密码</h2>
      <form method="post">
        <div class="row">
          <div class="col-8 col-lg-4 col-centered">
            <p>
              <label class="input-label" for="id_phone_number">账号</label>
              <input
                v-model="phone"
                type="text"
                name="phone_number"
                maxlength="11"
                class="form-controls"
                id="id_phone_number"
              />
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8 col-lg-4 col-centered">
            <p>
              <label class="input-label" for="id_name">原密码</label>
              <input
                type="password"
                name="business_name"
                maxlength="60"
                required
                class="form-controls"
                v-model="oldPassword"
                id="id_business_name"
              />
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8 col-lg-4 col-centered">
            <p>
              <label class="input-label" for="id_name">新密码</label>
              <input
                type="password"
                name="business_name"
                maxlength="60"
                required
                class="form-controls"
                v-model="newPassword"
                id="id_business_name"
              />
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-8 col-lg-4 col-centered">
            <p>
              <label class="input-label" for="id_name">确认密码</label>
              <input
                type="password"
                maxlength="60"
                class="form-controls"
                v-model="confirm_password"
                id="id_business_website"
              />
            </p>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-8 col-lg-4 col-centered">
            <label class="input-label">图片验证码</label>
            <div class="form-row">
              <div class="col">
                <input type="text" class="form-control" maxlength="6" v-model="verifyCode">
              </div>
              <div class="col">
                <img id="verifyCode" style="width:100%;height:3em"
                  :src="this._Global.HTTP_SERVER+'/updatepassword/verficationCode'" @click="verifyCodeRefresh"
                  onmouseover="this.style.cursor='pointer'">
              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-8 col-lg-4 col-centered">
            <label class="input-label">短信验证码</label>
            <div class="form-row">
              <div class="col">
                <input type="text" class="form-control" maxlength="6" v-model="smsCode">
              </div>
              <div class="col">
                <button id="btn_send_sms" @click="sendSmsCode(120)" type="button"
                  style="width:100%;height:3em;margin-top:0.5em" class="btn btn-dark form-control">获取验证码</button>
              </div>
            </div>
          </div>
        </div> -->
        <p></p>
        <div style="text-align: center">
          <button
            @click="update_password"
            style="width: 33%; height: 3em"
            class="btn btn-success"
            type="button"
          >
            修改
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
var self;
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      phone: "",
      password: "",
      oldPassword: "",
      newPassword: "",
      confirm_password: "",
      smsCode: "",
      verifyCode: "",
      verifyCodeRefreshTime: 600,
    };
  },
  mounted() {
    self = this;
    // this.verifyCodeTimeRefresh(this.verifyCodeRefreshTime);
    // this.verifyCodeRefresh()
    this.getAccount((account) => {
      this.phone = account.account;
    });
  },
  methods: {
    update_password: function () {
      if (
        this.phone == null ||
        this.phone == "" ||
        this.oldPassword == null ||
        this.oldPassword == "" ||
        this.newPassword == "" ||
        this.newPassword == ""
      ) {
        this.errToastr("账号、原密码、新密码不能为空");
        return;
      }

      if (this.confirm_password != this.newPassword) {
        this.errToastr("密码和确认密码不一致");
        return;
      }
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/update/password1", {
          phone: this.phone,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          authToken: this.getToken(),
        })
        .then((response) => {
          self.respDataHandle(response.body, (respData) => {
            this.$message({
              message: "密码修改成功",
              type: "success",
            });
          });
        });
    },
    sendSmsCode: function (seconds) {
      if (this.phone == "" || this.verifyCode == "") {
        this.errToastr("手机号或图片验证码不能为空");
        return;
      }

      this.$http
        .post(this._Global.HTTP_SERVER + "/updatepassword/sms_code", {
          phone: this.phone,
          verifyCode: this.verifyCode,
        })
        .then((response) => {
          self.respDataHandle(
            response.body,
            function (respData) {
              console.log("tag", respData);
              if (respData) {
                $("#btn_send_sms").text("获取验证码 " + seconds + "s");
                $("#btn_send_sms").attr("disabled", true);
                self.timeRefresh(seconds);
              }
            },
            function () {
              $("#verifyCode").attr(
                "src",
                this._Global.HTTP_SERVER +
                  "/updatepassword/verficationCode?" +
                  Math.random()
              );
            }
          );
        });
    },
    timeRefresh: function (seconds) {
      setTimeout(function () {
        seconds--;
        if (seconds > 0) {
          console.log("tag", seconds);
          $("#btn_send_sms").text("获取验证码 " + seconds + "s");
          $("#btn_send_sms").attr("disabled", true);
          self.timeRefresh(seconds);
        } else {
          $("#btn_send_sms").text("获取验证码");
          $("#btn_send_sms").attr("disabled", false);
        }
      }, 1000);
    },
    verifyCodeRefresh: function () {
      $("#verifyCode").attr(
        "src",
        this._Global.HTTP_SERVER + "/updatepassword/verficationCode?" + Math.random()
      );
    },
    verifyCodeTimeRefresh: function (seconds) {
      setTimeout(function () {
        seconds--;
        if (seconds <= 0) {
          $("#verifyCode").attr(
            "src",
            self._Global.HTTP_SERVER + "/updatepassword/verficationCode?" + Math.random()
          );
          seconds = self.verifyCodeRefreshTime;
        }
        // console.log('verifyCodeTimeRefresh ==>', seconds)
        self.verifyCodeTimeRefresh(seconds);
      }, 1000);
    },
  },
};
</script>

<style scoped>
.container-fluid {
  margin-top: 6em;
}
</style>



// WEBPACK FOOTER //
// src/components/UpdatePassword.vue